import { isDirty } from 'redux-form'
import { put, select, takeLatest } from 'redux-saga/effects'
import { IChangeReservationFormConfiguration } from '../../../actions/bookingCalendar/reservationModal/changeConfiguration'
import { setFieldsVisibility } from '../../../actions/bookingCalendar/reservationModal/fieldVisibility'
import { ToggleCreateModal } from '../../../actions/bookingCalendar/reservationModal/toggleConfigurationModal'
import fireToastSuccess from '../../../actions/toasts/fireToastSucces'
import {
  FORM_NAME,
  ReservationFormFieldVisibility,
} from '../../../containers/Form/CreateReservation/withReduxForm'
import { localStorage } from '../../../database'
import i18n from '../../../i18n'
import {
  ConfigurationModalActions,
  ReservationModalActions,
} from '../../../reducers/bookingCalendar/actionNames'
import { UserAccountActions } from '../../../reducers/userAccount/actionNames'
import { isNewAccount } from '../../../reducers/userAccount/selectors/userAccount'

function* saveFieldVisibility(action: IChangeReservationFormConfiguration) {
  const { fieldVisibility } = action.event
  const { UserDriver: Driver, Names } = localStorage
  const { ReservationForm } = Names
  Driver.setItem(
    ReservationForm.FieldVisibility,
    JSON.stringify(fieldVisibility),
  )

  yield put(setFieldsVisibility(fieldVisibility))
  yield put({ type: UserAccountActions.SaveReservationFormSettings })
  yield put(ToggleCreateModal(false))
}

function* loadFieldVisibility() {
  const { UserDriver: Driver, Names } = localStorage
  const { ReservationForm } = Names

  const isNew = yield select(isNewAccount)

  const fieldVisibility = new ReservationFormFieldVisibility(isNew)
  const item = Driver.getItem(ReservationForm.FieldVisibility, '')
  if (item) {
    const items = JSON.parse(item)
    Object.keys(fieldVisibility).forEach(k => {
      return (fieldVisibility[k] = items[k])
    })
  }
  yield put(setFieldsVisibility(fieldVisibility))
}

function* showToastOnChanges() {
  const dirty = yield select(isDirty(FORM_NAME))

  if (dirty) {
    yield put(
      fireToastSuccess(
        i18n.t('BBO_954_reservation_form_settings_changed'),
        null,
        'Event',
        'reservationSettingsChanged',
      ),
    )
  }
}

export default function*() {
  yield takeLatest(
    ConfigurationModalActions.ChangeConfiguration,
    saveFieldVisibility,
  )
  yield takeLatest(
    ReservationModalActions.ToggleCreateReservationModalRedux,
    loadFieldVisibility,
  )
  yield takeLatest(
    ReservationModalActions.ToggleUpdateReservationModalRedux,
    loadFieldVisibility,
  )
  yield takeLatest(
    ConfigurationModalActions.ChangeConfiguration,
    showToastOnChanges,
  )
}
